import ChevronLeft from "../../../img/icons/chevron-left.svg?react";
import ChevronRight from "../../../img/icons/chevron-right.svg?react";
import { rtlRotate180 } from "../../../styles/utils.css";
import IconButtonLink from "../../links/IconButtonLink";
import { IconButton } from "../IconButton";
import { PagerButtonProps } from "./types";

const PagerButton = ({
  onPress,
  isDisabled,
  label,
  direction,
  url,
}: PagerButtonProps) => {
  const chevronIcon =
    direction === "right" ? (
      <ChevronRight width={16} height={16} className={rtlRotate180} />
    ) : (
      <ChevronLeft width={16} height={16} className={rtlRotate180} />
    );

  return url ? (
    <IconButtonLink
      to={url}
      icon={chevronIcon}
      label={label}
      appearance="tonal"
      aria-disabled={isDisabled}
    />
  ) : (
    <IconButton
      icon={chevronIcon}
      label={label}
      appearance="tonal"
      isDisabled={isDisabled}
      onPress={onPress}
    />
  );
};

export default PagerButton;
